import { Dialog } from "@material-ui/core";
import "./style.scss";
// Import Icons
import Tippy from "../Tippy";
import Twitter from "../../../assets/icons/twitter.svg";
import Medium from "../../../assets/icons/medium.svg";
import Discord from "../../../assets/icons/discord.svg";
import { Tooltip } from 'react-tippy';
import { useSelector } from "react-redux";

const WalletSettingsPopup = ({open, onClose}) => {

  const state = useSelector((state) => state.storage);
  function logout() {
    localStorage.setItem("provider",null);
    window.location.reload();
  }

  return <Dialog
    classes={{ root: "popup_container", paper: "walletSettingsPopup" }}
    aria-labelledby="simple-dialog-title"
    open={open}
    onClose={onClose}
  >
    <div className="topBar">
      <p className="title">Settings</p>
      <p className="escape" onClick={onClose}>esc</p>
    </div>
    <div className="info">
      <span>Wallet Address: </span>
      <Tooltip title={"Click to copy"}>
        <p onClick={() => navigator.clipboard.writeText(state.publicKey)}>
          {state.publicKey && state.publicKey.toBase58()}
        </p>
      </Tooltip>
      <span>
        <div>
          <p>Referral Link:</p>
          <Tippy content={"Share your referral link with your friends and social media"}/>
        </div>
      </span>
      <Tooltip title={"Click to copy"}>
        <p onClick={() => navigator.clipboard.writeText(
          "https://prism.ag/?r="+(state.publicKey ? state.publicKey.toBase58().slice(0, 10) : "")
        )}>
          {"https://prism.ag/?r="}{state.publicKey && state.publicKey.toBase58().slice(0, 10)}
        </p>
      </Tooltip>
      
    </div>
    <div className="midBar">
      <p className="title">Find us on:</p>
      <div className="flex" style={{marginTop:"1rem"}}>
        <a href="https://twitter.com/prism_ag" style={{marginRight:"1rem"}} target="_blank"><img src={Twitter} height="25"/></a>
        <a href="https://discord.gg/prism-ag" style={{marginRight:"1rem"}} target="_blank"><img src={Discord} height="30"/></a>
        <a href="https://medium.com/@prism_ag" target="_blank"><img src={Medium} height="25"/></a>
      </div>
    </div>
    
    <div className="button" onClick={() => logout()}>
      Log out
    </div>
  </Dialog>
}

export default WalletSettingsPopup;

